import { render } from "./Logo.vue?vue&type=template&id=672d36f6"
const script = {}

import exportComponent from "/Users/sarahmarinoff/Sites/fc2025/wp-content/plugins/baytek-portal-helper/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Logo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "672d36f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('672d36f6', __exports__)) {
    console.log('reload')
    api.reload('672d36f6', __exports__)
  }
  
  module.hot.accept("./Logo.vue?vue&type=template&id=672d36f6", () => {
    console.log('re-render')
    api.rerender('672d36f6', render)
  })

}


export default __exports__